import { useEffect } from "react";
import { useTheme } from "../../stores/useTheme";
import { getUrlParam } from "@ihs-widget/utils/functions";
import { T, UrlParams } from "@ihs-widget/utils/enums";
import RefreshIconAndText from "@ihs-widget/components/common/RefreshIconAndText";

export const NotFound = () => {
    const { theme, toggleTheme } = useTheme();
    const themeURL = getUrlParam(UrlParams.THEME);


    useEffect(() => {
        if (themeURL) {
            toggleTheme(themeURL);
        }
    }, [themeURL])

    
    return (
        <div className={`w-full h-full ${theme === T.DARK ? T.DARK : ''}`}>
            <RefreshIconAndText addClass="pt-[100px]" />
        </div>
    );
}
